import heic2any from "heic2any"

export const toBase64 = async (file: File, stripPrefix = true): Promise<string> => {
  const isHEIC = ["image/heic", "image/heif"].includes(file.type)

  let targetFile = file

  if (isHEIC) {
    try {
      const convertedBlob = (await heic2any({
        blob: file,
        toType: "image/jpeg",
        quality: 0.9,
      })) as Blob

      targetFile = new File([convertedBlob], file.name.replace(/\.[^/.]+$/, ".jpg"), {
        type: "image/jpeg",
      })
    } catch (err) {
      return Promise.reject(new Error("Failed to convert HEIC to JPEG"))
    }
  }

  return new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onload = () => {
      const result = reader.result as string | null

      if (!result) {
        return reject(new Error("FileReader result is null"))
      }

      if (stripPrefix) {
        const base64Content = result.split(",")[1]
        if (base64Content) {
          return resolve(base64Content)
        } else {
          return reject(new Error("Failed to parse Base64 string"))
        }
      }

      resolve(result)
    }

    reader.onerror = () => {
      reject(new Error("Failed to read file as Base64"))
    }
    reader.readAsDataURL(targetFile)
  })
}
